module.exports = __webpack_public_path__ + "static/media/42x42-10.83117266.png";